import React from 'react';

const CreateOrderModal = () => {
	return (
		<div>
			<div className="popup-wrapper">
				{/* supplier-upload-modal */}
				<div className="common-popup create-order-modal">
					<div className="common-popup-header d-flex justify-content-between">
						<div className="popup-tilte">
							<h3 className="semibold-16 mb-0">Create order</h3>
						</div>
						<div className="close-btn">
							<img src="/icons/close.svg" alt="close" />
						</div>
					</div>
					<div className="common-popup-body">
						<div className="create-order-form">
							<div className="row">
								<div className="col-md-4">
									<div className="form-group">
										<label htmlFor="collection">Order title*</label>
										<input type="text" className="w-100" placeholder="Critical POM" />
									</div>
								</div>
								<div className="col-md-8">
									<div className="form-group">
										<div className="select-component">
											<label htmlFor="collection">Project Manager*</label>
											<div
												className="click-box click mb-1"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<p className="regular-14 ">Armhole</p>
												<img
													src="../../public%PUBLIC_URL%/images/chevron_down.svg"
													alt=""
												/>
											</div>
											<div className="dropdown-box dropdown-menu">
												<div className="m-0 search-filter">
													<div className="with-icon right-icon">
														<input
															type="text"
															placeholder="Search"
															defaultValue
														/>
														<span className="right-icon">
															<img src="../../public/icons/search.png" alt="" />
														</span>
													</div>
												</div>
												<div className="list-items scroll-y-label">
													<div className="single-item">
														<p>Armhole</p>
													</div>
													<div className="single-item">
														<p>Item 2</p>
													</div>
													<div className="single-item">
														<p>Item 3</p>
													</div>
													<div className="single-item">
														<p>Item 4</p>
													</div>
													<div className="single-item">
														<p>Item 5</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-4">
									<div className="form-group">
										<div className="select-component">
											<label htmlFor="collection">Account Manager*</label>
											<div
												className="click-box click mb-1"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<p className="regular-14 ">Armhole</p>
												<img
													src="../../public%PUBLIC_URL%/images/chevron_down.svg"
													alt=""
												/>
											</div>
											<div className="dropdown-box dropdown-menu">
												<div className="m-0 search-filter">
													<div className="with-icon right-icon">
														<input
															type="text"
															placeholder="Search"
															defaultValue
														/>
														<span className="right-icon">
															<img src="../../public/icons/search.png" alt="" />
														</span>
													</div>
												</div>
												<div className="list-items scroll-y-label">
													<div className="single-item">
														<p>Armhole</p>
													</div>
													<div className="single-item">
														<p>Item 2</p>
													</div>
													<div className="single-item">
														<p>Item 3</p>
													</div>
													<div className="single-item">
														<p>Item 4</p>
													</div>
													<div className="single-item">
														<p>Item 5</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-8">
									<div className="form-group">
										<div className="select-component">
											<label htmlFor="collection">Select buyer*</label>
											<div
												className="click-box click mb-1"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<p className="regular-14 ">Armhole</p>
												<img
													src="../../public%PUBLIC_URL%/images/chevron_down.svg"
													alt=""
												/>
											</div>
											<div className="dropdown-box dropdown-menu">
												<div className="m-0 search-filter">
													<div className="with-icon right-icon">
														<input
															type="text"
															placeholder="Search"
															defaultValue
														/>
														<span className="right-icon">
															<img src="../../public/icons/search.png" alt="" />
														</span>
													</div>
												</div>
												<div className="list-items scroll-y-label">
													<div className="single-item">
														<p>Armhole</p>
													</div>
													<div className="single-item">
														<p>Item 2</p>
													</div>
													<div className="single-item">
														<p>Item 3</p>
													</div>
													<div className="single-item">
														<p>Item 4</p>
													</div>
													<div className="single-item">
														<p>Item 5</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-4">
									<div className="form-group">
										<div className="select-component">
											<label htmlFor="collection">Brand</label>
											<div
												className="click-box click mb-1"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<p className="regular-14 ">Armhole</p>
												<img
													src="../../public%PUBLIC_URL%/images/chevron_down.svg"
													alt=""
												/>
											</div>
											<div className="dropdown-box dropdown-menu">
												<div className="m-0 search-filter">
													<div className="with-icon right-icon">
														<input
															type="text"
															placeholder="Search"
															defaultValue
														/>
														<span className="right-icon">
															<img src="../../public/icons/search.png" alt="" />
														</span>
													</div>
												</div>
												<div className="list-items scroll-y-label">
													<div className="single-item">
														<p>Armhole</p>
													</div>
													<div className="single-item">
														<p>Item 2</p>
													</div>
													<div className="single-item">
														<p>Item 3</p>
													</div>
													<div className="single-item">
														<p>Item 4</p>
													</div>
													<div className="single-item">
														<p>Item 5</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-4">
									<div className="form-group">
										<div className="select-component">
											<label htmlFor="collection">Sub-brand</label>
											<div
												className="click-box click mb-1"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<p className="regular-14 ">Armhole</p>
												<img
													src="../../public%PUBLIC_URL%/images/chevron_down.svg"
													alt=""
												/>
											</div>
											<div className="dropdown-box dropdown-menu">
												<div className="m-0 search-filter">
													<div className="with-icon right-icon">
														<input
															type="text"
															placeholder="Search"
															defaultValue
														/>
														<span className="right-icon">
															<img src="../../public/icons/search.png" alt="" />
														</span>
													</div>
												</div>
												<div className="list-items scroll-y-label">
													<div className="single-item">
														<p>Armhole</p>
													</div>
													<div className="single-item">
														<p>Item 2</p>
													</div>
													<div className="single-item">
														<p>Item 3</p>
													</div>
													<div className="single-item">
														<p>Item 4</p>
													</div>
													<div className="single-item">
														<p>Item 5</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-4">
									<div className="form-group">
										<div className="select-component">
											<label htmlFor="collection">Revenue stream</label>
											<div
												className="click-box click mb-1"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<p className="regular-14 ">Armhole</p>
												<img
													src="../../public%PUBLIC_URL%/images/chevron_down.svg"
													alt=""
												/>
											</div>
											<div className="dropdown-box dropdown-menu">
												<div className="m-0 search-filter">
													<div className="with-icon right-icon">
														<input
															type="text"
															placeholder="Search"
															defaultValue
														/>
														<span className="right-icon">
															<img src="../../public/icons/search.png" alt="" />
														</span>
													</div>
												</div>
												<div className="list-items scroll-y-label">
													<div className="single-item">
														<p>Armhole</p>
													</div>
													<div className="single-item">
														<p>Item 2</p>
													</div>
													<div className="single-item">
														<p>Item 3</p>
													</div>
													<div className="single-item">
														<p>Item 4</p>
													</div>
													<div className="single-item">
														<p>Item 5</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-4">
									<div className="form-group">
										<label htmlFor="collection">PO number</label>
										<input type="text" className="w-100" />
									</div>
								</div>
								<div className="col-md-4">
									<div className="form-group">
										<label htmlFor="collection">PO receive date</label>
										<input type="date" className="w-100" />
									</div>
								</div>
								<div className="col-md-4">
									<div className="form-group">
										<label htmlFor="collection">ETD (Estimated Time of Delivery)*</label>
										<input type="date" className="w-100" />
									</div>
								</div>
							</div>
						</div>
						<div className="create-order-form po-upload-and-file">
							<div className="row">
								<div className="col-md-12 pr-2">
									<div className="upload-img mb-2">
										<div className="file-uploader small upload-design-image mb-4 mb-sm-0">
											<div className="d-flex justify-content-start align-items-center">
												<label
													htmlFor="drag-upload"
													className="drag-upload d-flex justify-content-center align-items-center"
												>
													<img src="/icons/upload-blue.svg" width={24} />
													<p className="ml-1">Upload PO</p>
												</label>
												<p className="regular-14 gray_dark_02 pl-4">No PO uploaded</p>
											</div>
											<input
												type="file"
												id="drag-upload"
												className="file-upload"
												name="image"
												accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"
											/>
										</div>
										<div className="all-pdf-files mt-3 d-flex flex-wrap justify-content-start align-items-center">
											<div className="single-pdf-file d-flex align-items-center mr-4">
												<img src="/images/file-pdf.svg" width={24} />
												<p className="regular-14 gray_dark_01 pl-1">
													BMW PO/2021/202..
												</p>
												<div className="acton-img cursor-pointer">
													<img src="/icons/delete_red.svg" width={20} />
												</div>
											</div>
											<div className="single-pdf-file d-flex align-items-center mr-4">
												<img src="/images/file-pdf.svg" width={24} />
												<p className="regular-14 gray_dark_01 pl-1">
													BMW PO/2021/202..
												</p>
												<div className="acton-img cursor-pointer">
													<img src="/icons/delete_red.svg" width={20} />
												</div>
											</div>
											<div className="single-pdf-file d-flex align-items-center mr-4">
												<img src="/images/file-pdf.svg" width={24} />
												<p className="regular-14 gray_dark_01 pl-1">
													BMW PO/2021/202..
												</p>
												<div className="acton-img cursor-pointer">
													<img src="/icons/delete_red.svg" width={20} />
												</div>
											</div>
											<div className="single-pdf-file d-flex align-items-center mr-4">
												<img src="/images/file-pdf.svg" width={24} />
												<p className="regular-14 gray_dark_01 pl-1">
													BMW PO/2021/202..
												</p>
												<div className="acton-img cursor-pointer">
													<img src="/icons/delete_red.svg" width={20} />
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="modal-footer">
						<div className="footer-buttons text-right">
							<button className="button outline size32 ml-2">Submit</button>
							<button className="button size32 ml-2">Submit</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CreateOrderModal;
